import { ReactNode } from 'react';
import styled from 'styled-components';

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 12px;
  padding: 48px 24px;
  color: ${({ theme }) => theme.colors.textSecondary};
`;

const IconSlot = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: ${({ theme }) => theme.radius.pill};
  background: ${({ theme }) => theme.colors.bgMuted};
  color: ${({ theme }) => theme.colors.textMuted};
`;

const Title = styled.p`
  margin: 0;
  font-weight: 600;
  font-size: 15px;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

const Description = styled.p`
  margin: 0;
  font-family: ${({ theme }) => theme.font.secondary};
  font-size: 13.5px;
  max-width: 360px;
  color: ${({ theme }) => theme.colors.textSecondary};
`;

const Action = styled.div`
  margin-top: 8px;
`;

export const EmptyState = ({
  icon,
  title,
  description,
  action,
}: EmptyStateProps) => (
  <Wrapper role="status">
    {icon && <IconSlot aria-hidden="true">{icon}</IconSlot>}
    <Title>{title}</Title>
    {description && <Description>{description}</Description>}
    {action && <Action>{action}</Action>}
  </Wrapper>
);
